import { createApp, h } from 'vue';
import { createI18nMessage, helpers } from '@vuelidate/validators';
import ModellSelector from './components/modell-selector';
import ModellSelectorApp from './components/model-selector-app';
import {EventTypes} from './components/model-selector-events.js';

import i18n from './modellregister-i18n';


mcWeb.ModelRegister = new function () {
    this.groups = null;
    this.events = {
        onModelRegisterScriptLoaded: "onModelRegisterScriptLoaded"
    };
    this.initializeProductGroups = function(groups){
        this.groups = groups;
        if (groups === undefined)
            this.groups = null;
    };
    this.initializeModelRegisterInstance = function (webPubElmementId, isPublishMode ) {
        var elm = document.querySelector('#model-selector-form-' + webPubElmementId);
        if (!elm) {
            console.log("Failed to init modelreg with elmid:" + webPubElmementId);
            return;
        }

        var accessoriesPageUrl = elm.getAttribute("data-accessories-pageurl");
        var modellRegister = createApp({
            i18n,
            components: {
                'modell-selector': ModellSelector
            },
            data() {
                return {
                    accessoriesPageUrl: accessoriesPageUrl,
                    postedData: null,
                    isPublishMode: isPublishMode,
                    activeGroups : this.groups
                }
            },
            methods: {

            },
            created: function () {
            },
            beforeDestroy: function () {
            }
            , render: () => h(ModellSelector)
        });
        modellRegister.use(i18n);
        modellRegister.mount(elm);
        //return modelRegister;
    };


    this.setupModelregisterPage = function (elementId) {
        
        if (document.getElementById(elementId))
            console.log(elementId + " exist. App can be mounted.");
        else
            console.log(elementId + " doesn't exist. App cannot be mounted!");
        var modellRegisterApp = createApp({
            i18n,
            components: {
                'modell-selector-app': ModellSelectorApp,
                'modell-selector': ModellSelector
            },
            data() {
                return  {publishMode: document.querySelectorAll('body.publish-mode').length > 0}
            },
            
            props: {

            },
            methods: {
                addModel: function (plid) {
                    PubSub.publish(EventTypes.ADD_MODEL, plid);
                },
                removeModel: function (plid) {
                    PubSub.publish(EventTypes.REMOVE_MODEL, plid);
                },
                selectModel: function (plid) {
                    PubSub.publish(EventTypes.SELECT_MODEL, plid);
                }
            },
            expose: ['addModel','removeModel','selectModel'],
            created: function () {
            },
            beforeDestroy: function () {
            }
            ,render: () => h(ModellSelectorApp)
        });
        modellRegisterApp.use(i18n);
        var mountedApp = modellRegisterApp.mount(document.getElementById(elementId));
        return mountedApp;
    };

    PubSub.publish(this.events.onModelRegisterScriptLoaded);
};






